"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./ie-polyfills");
require("./dependencies");
// app must be imported first so "qualtrics.pr" angular module is setup.
require("./app");
// Files included in the webpack bundle.
require("./client-lib");
require("./less-lib");
